var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","strokeWidth":"1.5"},[React.createElement("line",{"x1":"9.9","y1":"13.1","x2":"3.2","y2":"19.8","key":0}),React.createElement("circle",{"cx":"14.2","cy":"8.8","r":"6.2","key":1})]));
}

Search.defaultProps = {"version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Search;

Search.default = Search;
